export default __webpack_public_path__ + "static/media/test3.1f048a7c.png";